module.exports = __webpack_public_path__ + "img/749f47b.png";